module.exports = __webpack_public_path__ + "img/phone1.552b4619.webp";